/** Thrown when a glass configuration is invalid; carries all Dutch messages. */
export class PricingError extends Error {
  constructor(public readonly errors: string[]) {
    super(errors.join(" "));
    this.name = "PricingError";
  }
}
